module.exports = __webpack_public_path__ + "images/hero-testimonials-page-reviews-mobile.webp";